import update from 'immutability-helper';
import { saveAs } from 'file-saver';

// Creates a reducer managing exports, given the action types to handle,
// and a function telling how to extract the key from an action.
const exportToFile = ({ types, mapActionToKey }) => {
	if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected types to be an array of three elements.');
	}
	if (!types.every(t => typeof t === 'string')) {
		throw new Error('Expected types to be strings.');
	}
	if (typeof mapActionToKey !== 'function') {
		throw new Error('Expected mapActionToKey to be a function.');
	}

	const [requestType, successType, failureType] = types;

	const initialState = {
		loading: false,
		format: 'Excel'
	};
	const updateExport = (state = initialState, action) => {
		switch (action.type) {
			case requestType:
				return update(state, {
					loading: { $set: true },
					format: { $set: action.format }
				});
			case successType:
				let saveAsFilename = 'export';
				if (action.filename) {
					if (typeof action.filename === 'string')
						saveAsFilename = action.filename;

					if (typeof action.filename === 'function')
						saveAsFilename = action.filename();
				}
				saveAs(action.response, saveAsFilename);

				return update(state, {
					loading: { $set: false }
				});
			case failureType:
				return update(state, {
					loading: { $set: false }
				});
			default:
				return state;
		}
	};

	return (state = {}, action) => {
		// Update pagination by key
		switch (action.type) {
			case requestType:
			case successType:
			case failureType:
				const key = mapActionToKey(action);
				if (typeof key !== 'string') {
					throw new Error('Expected key to be a string.');
				}
				return update(state, {
					[key]: { $set: updateExport(state[key], action) }
				});
			case 'LOGIN_SUCCESS':
				return {};
			default:
				return state;
		}
	};
};

export default exportToFile;